/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Point_2Inputs */

const en_guestlist_point_2 = /** @type {(inputs: Guestlist_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequences that follow up by themselves`)
};

/**
* | output |
* | --- |
* | "Sequences that follow up by themselves" |
*
* @param {Guestlist_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_point_2 = /** @type {((inputs?: Guestlist_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_point_2(inputs)
});